module.exports = __webpack_public_path__ + "static/img/nav-3.c552c21.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nav-3.png
// module id = HzDc
// module chunks = 1